import React from 'react';
import './ProfileTabs.css';
import Tab from './Tab/Tab';
import constants from '../../../constants/constants';

function ProfileTabs({ activeTab, changeTabHandler, counts = {} }) {
    const tabs = [
        { id: constants.TABS.MATCHES_TO_APPROVE_ID,          label: constants.TABS.MATCHES_TO_APPROVE },
        { id: constants.TABS.MATCHES_ARE_WAITING_ID,         label: constants.TABS.MATCHES_ARE_WAITING },
        { id: constants.TABS.MATCHES_REJECTED_MATCHES_ID,    label: constants.TABS.REJECTED_MATCHES },
        { id: constants.TABS.MATCHES_REJECTED_MATCHES_BY_ME_ID, label: constants.TABS.REJECTED_MATCHES_BY_ME },
    ];

    return (
        <div className='profile-tabs-bar'>
            {tabs.map((tab) => (
                <Tab
                    key={tab.id}
                    activeTab={activeTab}
                    changeTabHandler={changeTabHandler}
                    tabLabel={tab.label}
                    tabId={tab.id}
                    count={counts[tab.id] ?? 0}
                />
            ))}
        </div>
    );
}

export default ProfileTabs;
